import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import Header from "../components/Header";
import DashboardPartner from "../components/DashboardComponents/DashboardPartner";
import DashboardProfessionista from "../components/DashboardComponents/DashboardProfessionista";
import DashboardSuperAdmin from "../components/DashboardComponents/DashboardSuperAdmin";

const Dashboard = ({
  user,
  collaborators,
  evaluations,
  loadAppData,
  setAppLoading,
  appLoading,
  apiErrorModal,
}) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <div style={{ position: "fixed", top: 0, width: "100%", zIndex: 1000 }}>
        <Header />
      </div>

      <Grid
        container
        style={{ display: "flex", justifyContent: "center", flex: 1 }}
      >
        <Grid
          item
          container
          xs={11}
          sm={11}
          spacing={4}
          style={{
            marginTop: "120px",
            marginBottom: "30px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {user.role === "collaborator" && (
            <DashboardProfessionista
              loadAppData={loadAppData}
              user={user}
              evaluations={evaluations}
              appLoading={appLoading}
              setAppLoading={setAppLoading}
              apiErrorModal={apiErrorModal}
            />
          )}

          {user.role === "partner" && (
            <DashboardPartner
              loadAppData={loadAppData}
              user={user}
              collaborators={collaborators}
              evaluations={evaluations}
              appLoading={appLoading}
              setAppLoading={setAppLoading}
              apiErrorModalGeneral={apiErrorModal}
            />
          )}

          {user.role === "superadmin" && (
            <DashboardSuperAdmin
              user={user}
              evaluations={evaluations}
              appLoading={appLoading}
              setAppLoading={setAppLoading}
            />
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;
